import { render, staticRenderFns } from "./allIndex.vue?vue&type=template&id=6f07d9fa&scoped=true"
import script from "./allIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./allIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./allIndex.vue?vue&type=style&index=0&id=6f07d9fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07d9fa",
  null
  
)

export default component.exports